// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectPlaningStatusQueryResult, selectPlaningStatusesPageLoading, selectPlaningStatusesShowInitWaitingMessage} from '../_selectors/planing-status.selectors';

export class PlaningStatusesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectPlaningStatusesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectPlaningStatusesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectPlaningStatusQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
